import { render, staticRenderFns } from "./ArtDetail.vue?vue&type=template&id=3b9747ee&scoped=true&"
import script from "./ArtDetail.vue?vue&type=script&lang=js&"
export * from "./ArtDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArtDetail.vue?vue&type=style&index=0&id=3b9747ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9747ee",
  null
  
)

export default component.exports